import React, { useState } from "react";
import { Button, Typography } from '@material-ui/core';
import ModalPage from "components/explore/layout/ModalPage";
import { PDFObject } from 'react-pdfobject';
import { sendClientLog } from "services/logService";

export default function AboutDialogDocumentation() {
  const [isDocModalOpen, setIsDocModalOpen] = useState(false);
  const [docInfo, setDocInfo] = useState(null);

  const modalPage = () => {
    return (
      <ModalPage
        maxWidth="lg"
        height={window.innerHeight - 100}
        title={docInfo.title}
        open={isDocModalOpen}
        onClose={() => setIsDocModalOpen(false)}
        key={docInfo.text}
        disableBackdrop={false}
      >
        <div>
          <PDFObject url={docInfo.pdf} height='78vh' />
        </div>
      </ModalPage>
    )
  }
  const clickHandler = (doc) => {
    setDocInfo(doc);
    setIsDocModalOpen(true);
    sendClientLog('Info',`About ReVUe - User opened PDF with title ${doc.title}`);
  }
  const formatPdfLink = (pdfDoc) => {
    return (
      <div key={pdfDoc.title}>
        <Button
          color="primary"
          onClick={() => clickHandler(pdfDoc)}
        >
          {pdfDoc.text}
        </Button>
      </div>
    ) 
  }
  const formatLink = (doc) => {
    return (
      <>
        <div/>
        <Button
          color="primary"
          href={doc.link}
          target="_blank"
          rel="noopener"
          onClick={() => sendClientLog('Info',`About ReVUe - User opened link with text ${doc.text}`)}
        >
          {doc.text}
        </Button>
      </>
    ) 
  }
  return (
    <>
      <Typography variant='h6' style={{ fontSize: '1rem' }} display="block" gutterBottom>
        Explore documentation:
      </Typography>
      {formatPdfLink({ title: "Views Interface Guide", text: "Views Interface Guide", pdf: "/Explore_Views_Interface_Guide.pdf" })}
      <Typography variant='h6' style={{ marginTop: '20px', fontSize: '1rem' }} display="block" gutterBottom>
        Pricing documentation:
      </Typography>
      {formatPdfLink({ title: "Asset Level Underwriting Guide", text: "Asset Level Underwriting Guide", pdf: "/ReVUe_Acquisitions_Underwriting_Manual.pdf" })}
      {formatLink({ text: "Data Freshness Logic", link: "https://amherstgroup.atlassian.net/wiki/x/NgCcX" })}
      {formatLink({ text: "Buy Box Fit Logic", link: "https://amherst1.sharepoint.com/:w:/s/Developer-AcquisitionsTech/EdUKepb0qTVBlMaQqGsysFQB0_unxYo7JIIYCw21zMKELw?e=qhn9Mc" })}
      {formatPdfLink({ title: "Target Bid Price Logic", text: "Target Bid Price Logic", pdf: "/Target_Bid_Price_Logic.pdf" })}
      {formatPdfLink({ title: "Auto Pricing Waterfall Logic", text: "Auto Pricing Waterfall Logic", pdf: "/Autopricing_Waterfall_Logic_in_ReVUe.pdf" })}
      {formatLink({ text: "Comps Request Parameters", link: "https://amherst1.sharepoint.com/:x:/s/Developer-AcquisitionsTech/EThVBn0qoJpJoiqPP1fqjX8BGz3Izk-LyxvukW0mc77tXw?e=nuklhr" })}      
      {formatLink({ text: "Zip-to-Region Mapping", link: "https://amherst1.sharepoint.com/:x:/s/Developer-AcquisitionsTech/EYDHJAxyQKdGg9X-TQHQEGoB0mAUq0Ut8vxEXNCOqWCiGw?e=hOnlas" })}
      {formatLink({ text: "Exclusion Area Mapping", link: "https://amherst1.sharepoint.com/:x:/s/Developer-AcquisitionsTech/EVnsCjDLRINHo3GUfSjCjdoB0bdvhR8cTPO7rwhSK_HLnA" })}
      
      <Typography variant='h6' style={{ marginTop: '20px', fontSize: '1rem' }} display="block" gutterBottom>
        Data platform models & methodologies:
      </Typography>
      {formatPdfLink({ title: "MLS Inventory", text: "MLS Inventory", pdf: "/MLS Feed Inventory Filtering.pdf" })}
      {formatLink({ text: "AVM & ESP White Paper", link: "https://amherst1.sharepoint.com/:b:/s/EDM/ET1MwzmYU7hLpUeR6ScZocEBYhauu9KhWOsQahrGe3P6aw" })}
      {formatLink({ text: "Rent AVM White Paper", link: "https://amherst1.sharepoint.com/:b:/s/EDM/EYyfzOgoz5VJtcnoULmYadABOEFDPjpJGaD1iwEWzd5EQw" })}
      {formatPdfLink({ title: "Comps Types & Scoring", text: "Comps Types & Scoring", pdf: "/CompsTypes&Scoring_2020_03_06.pdf" })}
      {formatLink({ text: "Rent Growth Model", link: "https://amherst1.sharepoint.com/:b:/s/EDM/EcgPmm5i7kxDrayNMv7UqYoBPuaHHVhWAyOfXrTYOfa5oQ" })}
      {formatLink({ text: "Tax Model Methodology", link: "https://amherst1.sharepoint.com/:b:/s/EDM/EUiOEFloEjJPn3KwToBiOaEBdC8fkuSOxoLWeA83kcN02A" })}
      {isDocModalOpen && modalPage()}
    </>
  )
}